(function() {

    'use strict';

    angular.module('Services')
        .factory('Currency', function($http, $rootScope, Error, Request) {
            let getList = (callback, errCallback) =>{
                Request.get({
                    url: ApiURLs.currency.list,
                    successCallback: callback,
                    errorCallback: errCallback
                });
            };
            return {
                getList: getList
            };
        });
})();



// WEBPACK FOOTER //
// ./js/services/currency.js